<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row justify="space-around">
        <v-col cols="12" md="12">

          <!-- Left button -->
          <v-text-field
            disabled
            outlined
            v-model="leftButton"
            :label="$t('display/elevator:edit.labels.playlist-tab.left-button')"
          />

          <!-- Right button -->
          <v-text-field
            disabled
            outlined
            v-model="rightButton"
            :label="$t('display/elevator:edit.labels.playlist-tab.right-button')"
          />

          <!-- Carousel Settings -->
          <v-textarea
            disabled
            outlined
            v-model="carouselSettings"
            :label="$t('display/elevator:edit.labels.playlist-tab.carousel')"
            auto-grow
          />

          <!-- Rotation Settings -->
          <v-textarea
            disabled
            outlined
            v-model="rotationSettings"
            :label="$t('display/elevator:edit.labels.playlist-tab.rotation')"
            auto-grow
          />
          <v-col cols="12" md="3">
            <v-btn
              elevation="2"
              color="primary"
              @click="downloadPlaylist"
            >{{ $t('display/elevator:edit.labels.playlist-tab.download') }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: "PlaylistTab",
  data() {
    return {
      leftButton: null,
      rightButton: null,
      carouselSettings: null,
      rotationSettings: null
    }
  },
  methods: {
    downloadPlaylist() {
      ElevatorService.loadRawPlaylistInfo(
        this.$store.state.display.elevatorForm.elevator.id,
        (response) => {
          const blob = new Blob([JSON.stringify(response.data)], {type: 'javascript/json'});
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'playlist.json';
          link.click();
          URL.revokeObjectURL(link.href);
        }
      )

    }

  },
  created() {
    ElevatorService.loadPlaylistInfo(
      this.$store.state.display.elevatorForm.elevator.id,
      (response) => {
        this.rotationSettings = '';
        this.carouselSettings = '';
        if (typeof response.data.id != 'undefined') {
          this.leftButton = response.data.button_content_left.media_name + ' - ' + response.data.button_content_left.button_text;
          this.rightButton = response.data.button_content_right.media_name + ' - ' + response.data.button_content_right.button_text;

          let items = response.data.items;
          for (let i = 0; i < items.length; i++) {
            this.rotationSettings += items[i].media_name + "\n";
          }

          let carousels = response.data.carousel;
          for (let i = 0; i < carousels.length; i++) {
            this.carouselSettings += carousels[i].media_name + "\n";
          }
        }
      }
    )
  }
}
</script>
